import { useCallback } from 'react';
import { useDependencyGraphProvider } from '../DependencyGraphContext';
import type { EntityId } from '../../../../dependency/manager/types';

export function useGetSubscribeToDependencyUpdates() {
  const { subscriptionManager } = useDependencyGraphProvider();

  const subscribeToDependencyUpdates = useCallback(
    ({ callback, id, key = 'default' }: { callback: () => void; id: EntityId; key?: string }) => {
      subscriptionManager.subscribe({
        id,
        callback,
        key,
      });

      return () => {
        subscriptionManager.unsubscribe({
          id,
          key,
        });
      };
    },
    [subscriptionManager],
  );

  return { subscribeToDependencyUpdates };
}
